module.exports = __webpack_public_path__ + "img/dh_distral.e540443f.png";